import { makeStyles } from '@fluentui/react-components';
import { customTokens } from 'src/utils/theme';

export const useChallengeSectionStyles = makeStyles({
  cardsContainer: {
    display: 'flex',
    flexDirection: 'column',
    rowGap: customTokens.spacingVerticalL,
  },
});
